<template>
  <header>
        <div class="logoArea">
            <img alt="school logo" :src="schoolLogoFilePath"  class="logo" v-if="showHeader">
        </div>

        <div class="navArea" v-if="loggedIn">
            <button :class="navButtonClass('time')" @click="selectNav('time')" >
                Time
            </button>
            <button :class="navButtonClass('tpr')" @click="selectNav('tpr')" >
                {{tprbuttontext}}
            </button>
    
        </div>  
        
        <div class="userArea vertFlex rightjustified" v-if="loggedIn && showHeader">
            <p class="userlabel bold">{{loggedInUser.name}}</p>     
            <linkbutton @click="logout()" toplabel="Logout" />
            <!-- <updatepassword :isAdminChangePassword="false"   :username="username" /> --> 
            <p v-if="!online">OFFLINE</p>
        </div>
        
    </header>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import linkbutton from './controls/linkbutton.vue'
// import updatepassword from './actions/updatepassword.vue'
import datamethods from '../services/datamethods'
import adhelper from '../services/adhelper'
import format from '../format.js'
import securityhelper from '../services/securityhelper'
export default {
    name: "navheader",
    components:{
        linkbutton,

    },
    mixins:[datamethods, adhelper,format,securityhelper],
    data() {
        return {
            // schoolLogoFilePath:'./../' + window.SCHOOL_LOGO,
            schoolname:window.SCHOOL_NAME,
        };
    },
    computed:{
        ...mapFields([
            'currentNav',
            'loggedIn',
            'loggedInUser',
            'lastRefreshDateTime',
            'username',
            'oldpassword',
            'logoOverride',
            'imageBasePath',
            'showHeader',
            'online',
            'filter',
            'tprList',
            'tprFilter'
        ]),
        schoolLogoFilePath(){
            
                return './../' + window.SCHOOL_LOGO
            

        },
        showOpenClose(){
            if(window.SHOW_OPEN_CLOSE==undefined){return true}
            else{return window.SHOW_OPEN_CLOSE}
        },
        tprbuttontext(){
            if(this.tprList.length==0){return "TPR"}
            return "TPR (" + this.tprList.length +")"
        }
    },
    methods:{
        
        selectNav(name){
            this.currentNav=name;
        },
        navButtonClass(name){
            var c =""
            if(this.currentNav==name){
                c= "selectedNav"
            }else{
                c= "unselectedNav"
            }
            
            return c
        },
        logout(){
            if(window.USE_AD_SECURITY){this.logoutmsal();}
            this.loggedIn=false;
            //this.filter.locationId=-1
            this.resetfilter()
            
        
        },
        resetfilter(){

            this.filter.StartDateTime=this.$options.filters.formatDateForInputToday()
            this.filter.EndDateTime=this.$options.filters.formatDateForInputToday()
            this.filter.StudentID=-1
            this.filter.InstructorID=-1,
            this.filter.LocationID=-1
            this.filter.includeInactive=false
            this.filter.studentGroupId=-1
            this.filter.studentStartDate= null
            this.tprFilter.date1=this.$options.filters.formatDateForInputToday()
            this.tprFilter.date2=this.$options.filters.formatDateForInputToday()
            this.tprFilter.studentId=-1
            this.tprFilter.locationId=this.loggedInUser.LocationId
            this.tprFilter.includeInactive=false
            this.tprFilter.studentStartDate=null
            console.log('filter ' + this.filter.StartDateTime)
            },
        /* async getImageBasePath(){
            //call api
            var response = await this.callAPI_Image(null,'imagepath')
            //handle response
            if(response.Successful){
                this.imageBasePath = response.StringResponse
            }else{
                this.responseMessage = response.Message
            }
        }, */
    },
    mounted(){
        //this.getImageBasePath();
    }
}
</script>

<style>
header{

    padding:10px 20px 10px 10px;
    display:grid;
    grid-template-columns:2fr 4fr 2fr;
    grid-template-rows:auto;
    grid-template-areas: 
        "logo nav user";
    font-size:medium;
    background-color:var(--header-color);
 
}
.logo{
    max-width: 100%;
    max-height:75px;
}
.navArea{
    padding:0px;
    margin:0px;
}
.selectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: 4px solid var(--highlight-button-color);
    border-radius:2px;
    width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
     margin:10px;

}
.unselectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: none;
    border-radius:2px;
    width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
}
.hastpr{
    border:4px solid yellow;
}
.schoolname{
    font-size:large;
    text-align: center;
    margin:0px 0px 0px 20px;
}
.userlabel{
   
    margin:0px 0px 10px 0px;
    
}
.userArea{
  grid-area:user;
}
.modeImage{
    height:25px;
    margin:5px;
}
.buttoninside{
  display:flex;
  flex-direction: column;
  margin:0px;
    padding:0px;
}
.buttonlabel{
    margin:0px;
}
</style>